import React, { useState, useEffect } from "react";
import "./editpopup.css";
import { updateAddress } from "../../api/axios";
import Alert from "../common/Alert";

const AddressPopup = ({
  id,
  role,
  address,
  setVisible,
  setAlertMessage,
  setAlertSeverity,
  setOpenSnackbar,
  setAddress
}) => {
  // const [address, setAddress] = useState(currentAddress);
  //   const [alertMessage, setAlertMessage] = useState("");
  //   const [alertSeverity, setAlertSeverity] = useState("success"); // 'success', 'error', 'warning', 'info'
  //   const [openSnackbar, setOpenSnackbar] = useState(false);
  const [errors, setErrors] = useState({ address: "" });
  const token = localStorage.getItem("token");

  const validate = () => {
    let tempErrors = {};
    if (!address) {
      tempErrors.address = "Address is required.";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (e) => {
    setAddress(e.target.value);
  };

  const handleSave = async () => {
    try {
      const updatedUser = await updateAddress(id, address, role, token);
      // console.log("Updated user:", updatedUser);
      if (updatedUser.success) {
        setAlertMessage("Address updated successfully.");
        setAlertSeverity("success");
      } else {
        setAlertMessage("Failed to update address.");
        setAlertSeverity("error");
      }
    } catch (error) {
      setAlertMessage("Failed to update address.");
      setAlertSeverity("error");
      console.error("Failed to update address:", error);
    }
  };

  const saveAddess = () => {
    if (validate()) {
      handleSave();
      setOpenSnackbar(true);
      setVisible(false);
    }
  };

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <div className="edit-popup">
      <div className="edit-popup-content">
        <div className="edit-popup-header">
          <h2>Edit Address</h2>
        </div>
        <div className="edit-popup-body">
          <div className="edit-popup-field">
            <label>Address</label>
            <textarea
              type="text"
              name="address"
              value={address}
              onChange={handleChange}
              style={{ width: "100%" }}
            />

            {errors.address && <span className="error-text">{errors.address}</span>}
          </div>
        </div>
        <div className="edit-popup-footer">
          <button onClick={saveAddess}>Save</button>
          <button className="cancel-button" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </div>

      {/* openSnackbar={openSnackbar}
        alertSeverity={alertSeverity}
        setOpenSnackbar={setOpenSnackbar}
        alertMessage={alertMessage} */}

    </div>
  );
};

export default AddressPopup;
